/* istanbul ignore file */
import { AboutCompany } from './AboutCompany/AboutCompany';
import { Benefits } from './Benefits/Benefits';
import { HeaderLead } from './HeaderLead/HeaderLead';
import { ProspectHero } from './ProspectHero/ProspectHero';
import { HomeCounting } from './HomeCounting/HomeCounting';
import { ProfileForm } from './ProfileForm/ProfileForm';
import { RequestCallToAction } from './RequestCallToAction/RequestCallToAction';
import { Testimonials } from './Testimonials/Testimonials';
import { Bundles } from './Bundles/Bundles';
import { HowWorks } from './HowWorks/HowWorks';
import { HowMuch } from './HowMuch/HowMuch';
import { WhyUs } from './WhyUs/WhyUs';
import { Depoiments } from './Depoiments/Depoiments';
import { CIMessageDialog } from './CIMessageDialog/CIMessageDialog';

export {
  AboutCompany,
  Benefits,
  HeaderLead,
  ProspectHero,
  HomeCounting,
  ProfileForm,
  RequestCallToAction,
  Testimonials,
  Bundles,
  HowWorks,
  HowMuch,
  WhyUs,
  Depoiments,
  CIMessageDialog,
};
